module.exports = __webpack_public_path__ + "static/media/fj.0595e6e7.svg";